import { Avatar, Box, Heading, List, Text, TextInput } from 'grommet';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

const UserList = ({ users }: { users: object[] }) => {
  const history = useHistory();
  const [value, setValue] = useState('');
  const [list, setList] = useState(users);
  const onClick = (event: any) => history.push(`/${event.item.login}/repos`);
  const onChange = (event: any) => {
    setValue(event.target.value);
    let updatedList = users;
    updatedList = updatedList.filter(
      (u: any) =>
        u.login.toLowerCase().search(event.target.value.toLowerCase()) !== -1
    );
    setList(updatedList);
  };
  return (
    <Box pad="large" height="100%">
      <Heading level="3" size="large">
        Contributors
      </Heading>
      <Box margin="small">
        <TextInput placeholder="Search" value={value} onChange={onChange} />
      </Box>
      <List data={list} pad="small" onClickItem={onClick}>
        {(datum: any, index: number) => (
          <Box
            key={index}
            direction="row-responsive"
            gap="small"
            align="center"
          >
            <Avatar size="large" src={datum['avatar_url']} />
            <Text weight="bold">{datum.login}</Text>
          </Box>
        )}
      </List>
    </Box>
  );
};

export { UserList };
